import { type ComponentProps, type ComponentType, type ReactNode } from 'react';

import { type DiceGameTileType } from '@/common/types/dice-game';

import { CoinMiniGameTile } from '../CoinTile/CoinMiniGameTile.tsx';
import { StarsMiniGameTile } from '../StarsTile/StarsMiniGameTile.tsx';

import { tilesMap, type TilesMapType } from './config.ts';

interface TileSelectorProps<T extends DiceGameTileType> {
  kind: T;
  props: ComponentProps<TilesMapType[T]>;
}

const TileSelector = <T extends DiceGameTileType>({
  kind,
  props,
}: TileSelectorProps<T>): ReactNode | JSX.Element | null => {
  const Component = tilesMap[kind] as ComponentType<
    ComponentProps<TilesMapType[T]>
  >;

  if ('isSuperGame' in props && props.isSuperGame && kind === 'tgem') {
    return <CoinMiniGameTile {...props} />;
  }

  if ('isSuperGame' in props && props.isSuperGame && kind === 'str') {
    return <StarsMiniGameTile {...props} />;
  }

  return Component ? <Component {...props} /> : null;
};

export { TileSelector };
